import { branchSagaWatcher } from './containers/BranchEditing/saga';
import { SyncFaceIdWatcher } from './containers/BranchListContainer/saga';
import { settingsGlobSagaWatcher } from './containers/SettingsContainer/saga';
import {
  visitorDeleteSagaWatcher,
  visitorPhoneAddSagaWatcher,
  visitorPhoneDeleteSagaWatcher,
  visitorPhonesTabSagaWatcher,
  visitorsTabSagaWatcher,
  visitorAddOrUpdateSagaWatcher,
  visitorPhoneLatestSagaWatcher,
} from './containers/VisitorsTabContainer/services/saga';
import { delayReasonsTabSagaWatcher } from './containers/DelayReasonsTabContainer/services/saga';

export const adminModuleSaga = [
  branchSagaWatcher,
  settingsGlobSagaWatcher,
  SyncFaceIdWatcher,
  visitorsTabSagaWatcher,
  visitorPhonesTabSagaWatcher,
  visitorPhoneDeleteSagaWatcher,
  visitorDeleteSagaWatcher,
  visitorPhoneAddSagaWatcher,
  visitorAddOrUpdateSagaWatcher,
  visitorPhoneLatestSagaWatcher,
  delayReasonsTabSagaWatcher,
];
